import styled from '@emotion/styled';

import { GenericWizardSection } from '__components/GenericWizard';

export const DescriptionSection = styled(GenericWizardSection)`
  margin-top: 14px;
`;

export const UserDescriptionWrapper = styled.div<{ addTopSpacer: string }>`
  margin-top: ${({ addTopSpacer }) => addTopSpacer};
`;
